/**
 * Anonymous visitor tracking for unregistered users.
 * Generates a unique ID stored in localStorage.
 */
const API_URL = process.env.REACT_APP_BACKEND_URL;

function getAnonId() {
  let id = localStorage.getItem('lt_anon_id');
  if (!id) {
    id = 'anon_' + Math.random().toString(36).substr(2, 16) + Date.now().toString(36);
    localStorage.setItem('lt_anon_id', id);
  }
  return id;
}

export function trackVisit() {
  const anonId = getAnonId();
  fetch(`${API_URL}/api/anonymous/track`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ anon_id: anonId, event: 'visit' }),
  }).catch(() => {});
}

export function trackListen(trackId, seconds) {
  const anonId = getAnonId();
  fetch(`${API_URL}/api/anonymous/track`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ anon_id: anonId, event: 'listen', track_id: trackId, seconds }),
  }).catch(() => {});
}
